import React, { useState } from "react";
import { useSetRecoilState } from "recoil";
import AdminNavbar from "../../modules/admin/AdminNavbar";
import Table2 from "../../modules/layout/Table2";
import AdminAccountAddModal from "./AdminAccountAddModal";
import { isAccountAddCheckModalOpenState } from "../../../recoil/admin/examRoom";
import useExamRoomActions from "../../../api/hooks/admin/examRoom";
import { useQuery } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";

const AdminAccount = () => {
  const setIsAccountAddModalOpen = useSetRecoilState(
    isAccountAddCheckModalOpenState
  );

  const examRoomActions = useExamRoomActions();
  const { getRaterAccountList } = useExamRoomActions();

  const [isModalType, setModalType] = useState(true);
  const [isUserSn, setUserSn] = useState();
  const [deleteList, setDeleteList] = useState([]);

  const { data: userList } = useQuery({
    queryKey: ["getUserList", getRaterAccountList],
    queryFn: () => getRaterAccountList(),
    onSuccess: (result) => {
      console.log("result :", result);
    },
  });

  const deleteStart = () => {
    if (window.confirm("선택된 계정을 삭제하시겠습니까?")) {
      delRater.mutate({
        snList: deleteList,
      });
    } else {
      alert("취소되었습니다.");
    }
  };

  const delRater = useMutation(examRoomActions.deleteRaterAccount, {
    onSuccess: (context) => {
      window.location.reload();
    },
    onError: () => {
      alert("삭제실패.");
    },
  });

  const deleteListCheck = (user_sn, checked, userId) => {
    const tempDeleteList = deleteList;
    if (checked === true) {
      tempDeleteList.push(user_sn);
    }
    if (checked === false) {
      for (let i = 0; i < tempDeleteList.length; i++) {
        if (tempDeleteList[i] === user_sn) {
          tempDeleteList.splice(i, 1);
        }
      }
    }
    setDeleteList(tempDeleteList);
  };

  return (
    <>
      <div>
        <link rel="stylesheet" type="text/css" href="/css/admin.css" />
        <AdminNavbar />
        <div className="admin_content">
          <div className="content-title">
            <p className="account">계정관리</p>
          </div>
          <div className="content-cont">
            <div className="container">
              <div className="tab-title">
                <ul className="nav nav-tabs" id="myTab" role="tablist">
                  <li className="nav-item" role="presentation">
                    <button className="nav-link active" type="button">
                      계정목록
                    </button>
                  </li>
                </ul>
              </div>
              <div className="tab-content" id="myTabContent">
                <div
                  className="tab-pane fade show active"
                  id="home"
                  role="tabpanel"
                  aria-labelledby="home-tab"
                >
                  <div className="flex filtering">
                    <div>
                      <button
                        type="button"
                        className="btn-custom b-btn plus"
                        onClick={() => {
                          setUserSn(null);
                          setModalType(true);
                          setIsAccountAddModalOpen(true);
                        }}
                      >
                        계정추가
                      </button>
                      {/* <button className="btn-custom w-btn all-select-btn">
                        전체선택
                      </button> */}
                      <button
                        className="btn-custom w-btn del-btn"
                        onClick={() => {
                          deleteStart();
                        }}
                      >
                        삭제
                      </button>
                    </div>
                    {/* <div>
                      <input
                        type="text"
                        className="search-input"
                        placeholder="아이디 또는 이름"
                      />
                      <button className="btn-custom b-btn input-btn">
                        검색
                      </button>
                    </div> */}
                  </div>
                  <div
                    className="tableFixHead table-responsive"
                    style={{ maxHeight: "500px" }}
                  >
                    <Table2
                      className="question-table"
                      header={[
                        "선택",
                        "아이디",
                        "이름",
                        "이메일",
                        "연락처",
                        "수정",
                      ]}
                    >
                      {userList?.data?.map((user) => (
                        <tr key={user.sn}>
                          <td>
                            <label
                              className="check-container"
                              style={{ width: "18px" }}
                            >
                              <input
                                type="checkbox"
                                onClick={(e) => {
                                  deleteListCheck(
                                    user.sn,
                                    e.target.checked,
                                    user.id
                                  );
                                }}
                              />
                              <span className="checkmark"></span>
                            </label>
                          </td>
                          <td>{user.id}</td>
                          <td>{user.name}</td>
                          <td>{user.email}</td>
                          <td>{user.phone}</td>
                          <td>
                            <button
                              className="insert-modalbtn"
                              onClick={() => {
                                setModalType(false);
                                setUserSn(user.sn);
                                setIsAccountAddModalOpen(true);
                              }}
                            />
                          </td>
                        </tr>
                      ))}

                      {/*<tr>*/}
                      {/*  <td>*/}
                      {/*    <label className="check-container" style={{width:"18px"}}>*/}
                      {/*      <input type="checkbox" />*/}
                      {/*      <span className="checkmark"></span>*/}
                      {/*    </label>*/}
                      {/*  </td>*/}
                      {/*  <td>dd</td>*/}
                      {/*  <td>ddd</td>*/}
                      {/*  <td>dddd</td>*/}
                      {/*  <td>ddddd</td>*/}
                      {/*</tr>*/}
                    </Table2>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <AdminAccountAddModal modalType={isModalType} userSn={isUserSn} />
      </div>
    </>
  );
};

export default AdminAccount;
